var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxCheckedSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form Control Element"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Outer Rectangle",
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3801 7.08529C18.6091 7.29521 18.6246 7.65103 18.4146 7.88004L10.1646 16.88C10.061 16.9931 9.91561 17.059 9.76222 17.0623C9.60883 17.0656 9.46074 17.0062 9.35225 16.8977L5.60225 13.1477C5.38258 12.928 5.38258 12.5719 5.60225 12.3522C5.82192 12.1325 6.17808 12.1325 6.39775 12.3522L9.73233 15.6868L17.5854 7.11985C17.7953 6.89084 18.1511 6.87537 18.3801 7.08529Z",
    fill: "white",
    stroke: "#172B4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckedSvg);
export default __webpack_public_path__ + "static/media/CheckboxCheckedSvg.85d7d0ea6d9cb30b0e572253fb3e8387.svg";
export { ForwardRef as ReactComponent };